module.exports = __webpack_public_path__ + "726a349c18783e8bbe25b8256c988f9a.fbx";